import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./DemoPages/Login";
import SifremiUnuttum from "./DemoPages/Login/SifremiUnuttum";
import SifreSifirla from "./DemoPages/Login/SifreSifirla";
import ZorunluSifreDegistir from "./DemoPages/Login/ZorunluSifreDegistir";
import Main from "./DemoPages/Main";
import { AUTH_SESSION_EXPIRED_EVENT, endAuthSession } from "./services/authSession";

const AppRoot = () => {
  const [girisYapildi, setGirisYapildi] = useState(
    () => localStorage.getItem("pl_auth") === "1" && !!localStorage.getItem("pl_token")
  );
  const [zorunluSifre, setZorunluSifre] = useState(() => {
    try {
      const k = JSON.parse(localStorage.getItem("pl_kullanici") || "{}");
      return !!k.sifreDegistirmeZorunlu;
    } catch {
      return false;
    }
  });

  const handleLogin = () => {
    setGirisYapildi(true);
    try {
      const k = JSON.parse(localStorage.getItem("pl_kullanici") || "{}");
      setZorunluSifre(!!k.sifreDegistirmeZorunlu);
    } catch {
      setZorunluSifre(false);
    }
  };

  // Başka sekmeden çıkış yapılırsa veya localStorage temizlenirse yakala
  useEffect(() => {
    const oturumuKapat = () => {
      setGirisYapildi(false);
      setZorunluSifre(false);
    };

    const handleStorage = (e) => {
      if (e.key === "pl_auth" && e.newValue !== "1") {
        oturumuKapat();
      }
      if (e.key === "pl_kullanici") {
        try {
          const k = JSON.parse(e.newValue || "{}");
          setZorunluSifre(!!k.sifreDegistirmeZorunlu);
        } catch {
          setZorunluSifre(false);
        }
      }
    };
    const handleAuthExpired = () => {
      oturumuKapat();
    };

    window.addEventListener("storage", handleStorage);
    window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, handleAuthExpired);

    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, handleAuthExpired);
    };
  }, []);

  // Sayfa 1 gün boyunca açık (veya hareketsiz) kalırsa otomatik çıkış yap
  useEffect(() => {
    if (!girisYapildi) return;

    let otoCikisTimer;
    const BIR_GUN_MS = 24 * 60 * 60 * 1000; // 24 Saat

    const cikisYap = () => {
      setGirisYapildi(false);
      setZorunluSifre(false);
      alert("Oturum süreniz dolmuştur. Lütfen tekrar giriş yapın.");
      endAuthSession("idle-timeout");
    };

    const resetTimer = () => {
      clearTimeout(otoCikisTimer);
      otoCikisTimer = setTimeout(cikisYap, BIR_GUN_MS);
    };

    // İlk Timer'ı başlat
    resetTimer();

    // Etkileşim olursa süreyi sıfırla (Kullanıcı aktifse 1 günlük süre baştan başlar)
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    return () => {
      clearTimeout(otoCikisTimer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
    };
  }, [girisYapildi]);

  if (!girisYapildi) {
    return (
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/sifremi-unuttum" element={<SifremiUnuttum />} />
        <Route path="/sifre-sifirla" element={<SifreSifirla />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  if (zorunluSifre) {
    return (
      <Routes>
        <Route path="/zorunlu-sifre" element={<ZorunluSifreDegistir onTamamlandi={() => setZorunluSifre(false)} />} />
        <Route path="*" element={<Navigate to="/zorunlu-sifre" replace />} />
      </Routes>
    );
  }

  return <Main />;
};

export default AppRoot;
